import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../Assets/Css/manpower.css';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { FaCheckCircle } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import aboutmanpowerservice from '../Assets/Image/manpowerhousekeeping.avif'
import manpowerhousecta from '../Assets/Image/manpowerandhousekeepingcta.avif'

// Related Images for Manpower
import manpowerImg1 from '../Assets/Image/manpower1.avif'
import manpowerImg2 from '../Assets/Image/manpower2.avif'
import manpowerImg3 from '../Assets/Image/manpower3.jpg'

// Related Images for Housekeeping
import housekeepingImg1 from '../Assets/Image/housekeeping1.avif'
import housekeepingImg2 from '../Assets/Image/housekeeping2.avif'
import housekeepingImg3 from '../Assets/Image/housekeeping3.jpg'

export default function ManpowerandHousekeeping() {
  const testimonials = [
    {
      message: "Pradh's housekeeping team keeps our facility spotless and presentable every day. Their attention to detail is outstanding.",
      author: "Admin Head",
    },
    {
      message: "We’ve been using their industrial manpower services for over a year — reliable staff, minimal downtime, and great coordination.",
      author: "Plant Supervisor",
    },
    {
      message: "From daily maintenance to deep cleaning, their mechanized housekeeping team ensures high standards of hygiene and efficiency.",
      author: "Facility Manager",
    },
  ];

  const services = [
    {
      title: 'Industrial Manpower Services',
      description:
        'We provide skilled and semi-skilled industrial manpower tailored to meet your operational demands. Our workforce is trained to adapt quickly to factory environments, ensuring high productivity and safety. From machine operators to support staff, we supply manpower that fits seamlessly into your workflow.',
      // image: manpowerMain,
      relatedImages: [manpowerImg1, manpowerImg2, manpowerImg3],
      keyFeatures: [
        'Skilled, semi-skilled, and unskilled staff availability',
        'Shift-wise workforce deployment and management',
        'Trained for safety compliance and SOPs',
      ],
      applicationAreas: [
        'Manufacturing plants',
        'Logistics and warehousing',
        'Construction sites',
        'Processing units',
      ],
    },
    {
      title: 'Mechanized Housekeeping Services (Regular & Monthly)',
      description:
        'Our mechanized housekeeping service ensures deep cleaning using industrial-grade equipment such as auto scrubbers, high-pressure jets, and vacuum systems. Whether it’s daily maintenance or monthly deep cleans, our team ensures spotless, hygienic spaces across industrial and commercial setups.',
      // image: housekeepingMain,
      relatedImages: [housekeepingImg1, housekeepingImg2, housekeepingImg3],
      keyFeatures: [
        'Use of ride-on auto scrubbers, high-pressure jets',
        'Eco-friendly cleaning agents and trained personnel',
        'Custom cleaning schedules (daily/weekly/monthly)',
      ],
      applicationAreas: [
        'Factories and production units',
        'Warehouses and storage areas',
        'Corporate offices and IT parks',
        'Hospitals and educational institutions',
      ],
    },
  ];


  return (
    <div className="mainnav min-vh-100">

      <Helmet>
        {/* Basic SEO */}
        <title>Manpower & Housekeeping Services | Industrial & Commercial | Pradh</title>
        <meta
          name="description"
          content="Pradh offers expert manpower and mechanized housekeeping services for industrial and commercial facilities. Reliable staffing and spotless spaces, delivered seamlessly."
        />
        <meta
          name="keywords"
          content="Industrial Manpower Services, Mechanized Housekeeping, Factory Staffing, Commercial Cleaning, Shiftwise Workforce Deployment, Industrial Cleaning India, Facility Maintenance Services"
        />
        <meta name="author" content="Pradh Management Solutions" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Manpower & Housekeeping Services | Pradh" />
        <meta
          property="og:description"
          content="Discover Pradh's expert manpower and industrial housekeeping services. From skilled staffing to deep cleaning, we deliver productivity and hygiene together."
        />
        <meta property="og:url" content="https://pradh.com/manpower-housekeeping" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://pradh.com/images/manpower-housekeeping-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Manpower & Housekeeping Services | Pradh" />
        <meta
          name="twitter:description"
          content="Safe, efficient, and professional manpower and housekeeping services for factories, warehouses, offices, and more."
        />
        <meta name="twitter:image" content="https://pradh.com/images/manpower-housekeeping-banner.jpg" />

        {/* Canonical */}
        <link rel="canonical" href="https://pradh.com/manpower-housekeeping" />
      </Helmet>

      <section className="hero-sectionmanpower">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in">
            Manpower & Housekeeping <br /> Services
          </h1>
          <p data-aos="zoom-in" data-aos-delay="100">
            Expert staffing and cleaning for a seamless workspace.
          </p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">
            Get in Touch
          </a>
        </div>
      </section>

      {/* Overview Section */}
      <section className="about-us py-5">
        <Container>
          <Row>
            <Col md={5} className="d-flex justify-content-center align-items-center">
              <img
                src={aboutmanpowerservice}
                alt="About  Manpower & Housekeeping Services"
                className="img-fluid aboutsecimg rounded shadow mb-3"
                data-aos="zoom-in"
                data-aos-delay="100"
              />
            </Col>
            <Col md={7}>
              <h2 className="page-title text-center mb-3" data-aos="fade-up">Overview</h2>
              <p data-aos="zoom-in" data-aos-delay="100">
                At <strong style={{ color: '#04A1D3' }}>Pradh Management Solutions</strong>, we specialize in delivering reliable manpower and housekeeping services tailored to industrial and commercial needs. Our workforce is trained, disciplined, and equipped to handle high-demand environments with precision.
              </p>
              <p data-aos="zoom-in" data-aos-delay="100">
                From regular cleaning schedules to monthly mechanized housekeeping, we maintain hygiene standards that align with safety regulations and operational efficiency. Whether it's factory floor assistance or facility cleanliness, our solutions are built for productivity and peace of mind.
              </p>

            </Col>
          </Row>
        </Container>
      </section>


      <section className="service-display py-5 bg-light">
        <Container>
          <h2 className="text-center page-title mb-5" data-aos="fade-up">Our Services</h2>
          {services.map((service, idx) => (
            <Card className="mb-5 shadow-lg border-0 rounded-4 overflow-hidden" key={idx} data-aos="fade-up" data-aos-delay={idx * 100}>
              <Row className="g-0">
                <Col md={5}>
                  <Swiper
                    modules={[Autoplay, Pagination]}
                    autoplay={{ delay: 3000 }}
                    pagination={{ clickable: true }}
                    loop={true}
                    className="h-100"
                  >
                    {service.relatedImages.map((img, i) => (
                      <SwiperSlide key={i}>
                        <img
                          src={img}
                          alt={`Related ${i}`}
                          className="img-fluid w-100 h-100 object-fit-cover"
                          style={{ maxHeight: '400px' }}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
                <Col md={7}>
                  <Card.Body className="p-4">
                    <h4 className="mb-2" style={{ color: '#C52316' }}>{service.title}</h4>
                    <p className="text-muted">{service.description}</p>

                    <h5 className="mt-4 fw-semibold">Key Features</h5>
                    <ul className="list-unstyled">
                      {service.keyFeatures.map((feature, i) => (
                        <li key={i} className="mb-2">
                          <FaCheckCircle className="text-success me-2" />
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <h5 className="mt-3 fw-semibold">Application Areas</h5>
                    <ul className="ps-3 mb-0">
                      {service.applicationAreas.map((area, i) => (
                        <li key={i} className="mb-2 fs-6 text-dark">{area}</li>
                      ))}
                    </ul>

                  </Card.Body>
                </Col>
              </Row>
            </Card>
          ))}
        </Container>
      </section>

      {/* CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col md={7} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="100">
              <h2>Ready to experience reliable manpower and spotless spaces?</h2>
              <p className="lead">
                Let our experts handle it all – from skilled staffing to seamless housekeeping.
              </p>
              <a href="/contact" className="btn-get">Get in Touch</a>
            </Col>
            <Col md={5}>
              <div className="d-flex justify-content-center">
                <img
                  src={manpowerhousecta}
                  alt="MEP Services CTA"
                  className="img-fluid rounded shadow"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up">What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>

    </div>

  );
}
